<template>
  <el-dialog
    v-model="dialogVisible"
    append-to-body
    class="assistant-management__dialog"
    fullscreen
    :show-close="false"
  >
    <div class="assistant-management__setting-dialog">
      <div class="head">
        <div class="assistant-management__setting-header">
          <div class="assistant-management__setting-header-left">
            <button class="assistant-management__setting-back" type="button" @click="handleClose">
              <i class="icon-arrow-left-s-line t-iconfont"></i>
            </button>
            <div class="assistant-management__setting-header-content">
              <img
                :alt="drawerCoreInfo.title"
                class="assistant-management__setting-avatar"
                :src="drawerCoreInfo.icon"
              />
              <div class="assistant-management__setting-info">
                <div class="assistant-management__setting-name">{{ drawerCoreInfo.title }}</div>
                <div class="assistant-management__setting-meta">
                  <span class="assistant-management__setting-meta-label">可用人员：</span>
                  <span
                    v-if="drawerCoreInfo.permission"
                    class="assistant-management__setting-meta-value"
                    >{{ drawerCoreInfo.permission }}</span
                  >
                  <span v-else class="assistant-management__setting-meta-empty"
                    >暂无可用人员，请选择</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="assistant-management__setting-header-right">
            <button
              v-if="knowledgeType"
              class="assistant-management__setting-users"
              type="button"
              @click="handleConfigKnowledge"
            >
              <i class="icon-group-line t-iconfont"></i>
              <span>知识配置</span>
            </button>
            <button
              class="assistant-management__setting-users"
              type="button"
              @click="emit('configPermission')"
            >
              <i class="icon-group-line t-iconfont"></i>
              <span>配置可用人员</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content">
        <slot></slot>
      </div>
      <UploadKnowledge
        v-model:show="uploadKnowledgeVisible"
        :knowledge-type="knowledgeType"
      ></UploadKnowledge>
    </div>
  </el-dialog>
</template>

<script setup>
import { computed, ref } from 'vue'
import UploadKnowledge from './upload-knowledge.vue'

const emit = defineEmits(['update:settingDialogVisible', 'configPermission'])
const props = defineProps({
  settingDialogVisible: {
    type: Boolean,
    required: true
  },
  drawerCoreInfo: {
    type: Object,
    required: true
  },
  knowledgeType: {
    type: Number,
    default: null
  },
  beforeClose: {
    type: Function,
    default: null
  }
})
const uploadKnowledgeVisible = ref(false)

const dialogVisible = computed({
  get() {
    return props.settingDialogVisible
  },
  set(value) {
    emit('update:settingDialogVisible', value)
  }
})

const handleClose = async () => {
  if (props.beforeClose) {
    try {
      await props.beforeClose()
    } catch {
      return
    }
  }
  dialogVisible.value = false
}

const handleConfigKnowledge = () => {
  uploadKnowledgeVisible.value = true
}
</script>

<style lang="scss">
.assistant-management__dialog {
  margin: 0;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    width: 100%;
    height: 100%;
    padding: 0;
  }
}

.assistant-management__setting-dialog {
  width: 100%;
  height: 100%;
  background: #fff;
  position: relative;
  display: flex;
  flex-direction: column;

  > .head {
    flex-shrink: 0;
    padding: 16px 24px;
    box-sizing: border-box;
    background: #f7f8fa;
  }

  > .content {
    flex: 1;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
  }
}

.assistant-management__setting-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.assistant-management__setting-header-left {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  margin-right: 24px;
}
.assistant-management__setting-header-right {
  display: flex;
  gap: 12px;
}

.assistant-management__setting-back {
  width: 32px;
  height: 32px;
  padding: 0;
  margin-right: 12px;
  border: 0;
  background: transparent;
  color: #323233;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;

  .t-iconfont {
    font-size: 32px;
    line-height: 1;
  }
}

.assistant-management__setting-header-content {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
}

.assistant-management__setting-avatar {
  width: 40px;
  height: 40px;
  margin-right: 12px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  flex-shrink: 0;
  border: 0.83px solid #ffffff;
  box-shadow: 0px 0px 5.33px 0px rgba(56, 47, 220, 0.2);
}

.assistant-management__setting-info {
  min-width: 0;
  flex: 1;
}

.assistant-management__setting-name {
  margin-bottom: 4px;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  color: #323233;
}

.assistant-management__setting-meta {
  display: flex;
  align-items: center;
  min-width: 0;
  font-size: 12px;
  line-height: 16px;
}

.assistant-management__setting-meta-label {
  color: #646566;
  flex-shrink: 0;
}

.assistant-management__setting-meta-value {
  color: #323233;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.assistant-management__setting-meta-empty {
  font-size: 12px;
  line-height: 16px;
  color: #c8c9cc;
}

.assistant-management__setting-users {
  height: 32px;
  padding: 0 16px;
  border: 1px solid #e5e6eb;
  border-radius: 8px;
  background: #fff;
  color: #323233;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  flex-shrink: 0;

  .t-iconfont {
    margin-right: 8px;
    font-size: 16px;
    line-height: 1;
  }
}
</style>
